import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";
import moment from "moment-timezone";

import { Space, Form, Input, Button, Card, message, Radio } from "antd";
import { ArrowLeftOutlined, SaveOutlined } from "@ant-design/icons";

const UserEdit = (props) => {
    const params = useParams();
    const navigate = useNavigate();
    const cookies = new Cookies();
    const auth = cookies.get("authToken");
    const config = { headers: { "auth-token": auth } };
    const value = { userID: params.userID };

    const [form] = Form.useForm();

    const handleFinish = (values) => {
        handleSubmit(values);
    };

    const handleSubmit = async (data) => {
        console.log("ข้อมูลใหม่:", data);
        await axios.post("/api/user/updateUser", { id: params.userID, ...data }, config).then((response) => {
            message.success("ข้อมูลได้รับการบันทึกเรียบร้อยแล้ว!");
        });
    };

    useEffect(() => {
        const fetchUserDetail = async () => {
            await axios.post("/api/user/getUserDetail", value, config).then((response) => {
                console.log(response.data[0]);
                // setUserDetail(response.data[0]);
                form.setFieldsValue(response.data[0]);
            });
        };
        fetchUserDetail();
    }, [params]);

    return (
        <>
            <Space align="baseline" style={{ marginBottom: "10px" }}>
                <ArrowLeftOutlined onClick={() => navigate(-1)} />
                <h2>Edit User</h2>
            </Space>
            <Card title="แก้ไขข้อมูลผู้ใช้">
                <Form form={form} layout="vertical" onFinish={handleFinish}>
                    <Form.Item
                        label="ยศ / ตำแหน่งต่างๆ เช่น พล.ต.ต. ศจ."
                        name="name_title"
                        // rules={[{ required: true, message: "กรุณากรอกยศ / ตำแหน่งต่างๆ เช่น พล.ต.ต. ศจ." }]}
                    >
                        <Input placeholder="กรุณากรอกยศ / ตำแหน่งต่างๆ เช่น พล.ต.ต. ศจ." />
                    </Form.Item>
                    <Form.Item name="name_prefix" label="คำนำหน้าชื่อ">
                        <Radio.Group>
                            <Radio value="นพ.">นพ.</Radio>
                            <Radio value="พญ.">พญ.</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="ชื่อ" name="firstname" rules={[{ required: true, message: "กรุณากรอกชื่อ" }]}>
                        <Input placeholder="กรอกชื่อผู้ใช้" />
                    </Form.Item>
                    <Form.Item
                        label="นามสกุล"
                        name="lastname"
                        rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
                    >
                        <Input placeholder="กรุณากรอกนามสกุล" />
                    </Form.Item>
                    <Form.Item
                        label="หน่วยงานต้นสังกัด"
                        name="parent_organization"
                        rules={[{ required: true, message: "กรุณากรอกหน่วยงานต้นสังกัด" }]}
                    >
                        <Input placeholder="กรุณากรอกหน่วยงานต้นสังกัด" />
                    </Form.Item>
                    <Form.Item
                        label="ตำแหน่งที่ต้นสังกัด"
                        name="parent_organization_position"
                        rules={[{ required: true, message: "กรุณากรอกตำแหน่งที่ต้นสังกัด" }]}
                    >
                        <Input placeholder="กรุณากรอกตำแหน่งที่ต้นสังกัด" />
                    </Form.Item>
                    <Form.Item
                        label="อีเมล"
                        name="email"
                        rules={[{ required: true, type: "email", message: "กรุณากรอกอีเมลที่ถูกต้อง" }]}
                    >
                        <Input placeholder="example@email.com" />
                    </Form.Item>
                    <Form.Item name="role" label="ประเภทผู้ใช้">
                        <Radio.Group>
                            <Radio value="teacher">ผู้สอน</Radio>
                            <Radio value="student">ผู้เรียน</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item name="is_active" label="สถานะ">
                        <Radio.Group>
                            <Radio.Button value={1}>active</Radio.Button>
                            <Radio.Button value={0}>inactive</Radio.Button>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" icon={<SaveOutlined />} block>
                            บันทึกข้อมูล
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </>
    );
};

export default UserEdit;
